import cards from '~/assets/icons/cards.svg';
import cash from '~/assets/icons/cash.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { useInputAction } from '~/rage';
import { Currency, InputAction, WalletType } from '~/shared';
import { useSaveCharacter } from '../../hooks';
import {
	StyledContainer,
	StyledDivider,
	StyledPriceContainer,
	StyledUpdateButtonContent,
	StyledUpdateButtonsContainer,
} from './FinishEdit.styled';

const FinishEdit = () => {
	const { handleUpdate } = useSaveCharacter();
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	useInputAction(InputAction.CommonMenuAccept, () =>
		handleUpdate(WalletType.Cash),
	);

	return (
		<StyledContainer>
			<Text style={{ fontSize: 16, fontWeight: 500, color: '#ffffff' }}>
				Изменение внешности
			</Text>
			<StyledDivider style={{ marginTop: 16 }} />
			<StyledPriceContainer>
				<Text>Стоимость</Text>
				<Text>200 000</Text>
				<CurrencyIcon icon={rubleIcon} size={'md'} />
			</StyledPriceContainer>
			<StyledUpdateButtonsContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					onClick={() => handleUpdate(WalletType.Bank)}
				>
					<StyledUpdateButtonContent>
						<img src={cards} />
						<Text>Картой</Text>
					</StyledUpdateButtonContent>
				</Button>
				<Button
					color={ButtonColors.Buy}
					height={ButtonHeight.Height40}
					onClick={() => handleUpdate(WalletType.Cash)}
				>
					<StyledUpdateButtonContent>
						<img src={cash} />
						<Text>Наличными</Text>
					</StyledUpdateButtonContent>
				</Button>
			</StyledUpdateButtonsContainer>
			<StyledDivider style={{ marginTop: 20 }} />
			<Text
				style={{
					fontSize: 14,
					color: 'rgba(255,255,255,0.25)',
					textAlign: 'center',
					marginTop: 20,
				}}
			>
				Внешность можно изменять раз в 2 дня
				<br />
				<br />
				Либо же купите карточку с изменением вашей внешности в игровом магазине!
			</Text>
		</StyledContainer>
	);
};

export { FinishEdit };
